<template>
  <div>
    <div>
      <div class="pageContent-title flex gap-5">
        <span>{{ dataType }}所需资料介绍</span>
        <a-button class="app-btn info-btn" @click="add">
          <app-icon type="icon-tianjia"></app-icon>
          添加新资料
        </a-button>
        <a-button class="app-btn info-btn" @click="addFromModal">从模版里添加</a-button>
      </div>
      <div class="mt-3" v-for="(item, index) in materialList" :key="index">
        <div>
          <div
            class="flex gap-5 items-center list"
            @click="selectMaterial(item, index)"
          >
            <span class="pl-2">{{ item.materialName?item.materialName:'添加资料中...' }}</span>
            <a-tag v-if="item.materialType" color="#87d068">{{ item.materialType === 1 ? '电子资料':'纸制资料' }}</a-tag>
            <a-tag v-if="item.isRequired" color="#f50">必填</a-tag>
            <!-- <div class="materialType-btn">{{ item.materialType === 1 ? '电子资料':'纸制资料' }}</div>
            <div class="isRequired-btn" v-if="item.isRequired">必填</div> -->
            <div style="flex:1"></div>

            <a-button style="width:100px" type="primary" @click.stop="remove(item, index)">
              <app-icon type="icon-shanchu"></app-icon>
              删除
            </a-button>
          </div>
          <transition-group name="lyric">
            <div v-if="item.check" class="transition-all" :key="1">
              <a-form class="form" :form="form" :colon="false">
                <a-form-item label="资料名称" required>
                  <a-input
                    v-decorator="[
                      'materialName',
                      {
                        rules: [{ required: true, message: '资料名称不能为空' }],
                      }
                    ]"
                    placeholder="请输入资料名称"
                  ></a-input>
                </a-form-item>
                <a-form-item label="所需场景">
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'differentRegister',
                      {
                        rules: [{ required: true, message: '请选择' }],
                        initialValue: 0
                      }
                    ]"
                    showSearch
                    :filterOption="filterByPY$t"
                    :options="typesMap.differentRegisterList"
                    placeholder="请选择"
                  ></a-select>
                </a-form-item>
                <a-form-item v-if="dataType === '认证'" label="国家">
                  <!-- <a-select
                    class="form-control"
                    v-decorator="['countryName']"
                    showSearch
                    :filterOption="filterByPY$t"
                    :options="countryList"
                  ></a-select> -->
                  <a-select
                    class="form-control"
                    style="min-width:580px"
                    v-decorator="['countryName']"
                    mode="multiple"
                    showSearch
                    :filterOption="filterByPY$t"
                    :options="countryList"
                    placeholder="请选择"
                  ></a-select>
                </a-form-item>
                <a-form-item label="图标" required v-if="dataType !== '公证' && dataType !== '认证'">
                  <PictureCardUpload
                    :itemWidth="150"
                    :itemHeight="150"
                    v-decorator="[
                      'icon',
                      {
                        rules: [{ required: true, message: '图标不能为空' }],
                      },
                    ]"
                    placeholder="请上传图标"
                  ></PictureCardUpload>
                </a-form-item>
                <a-form-item label="资料必填" required>
                  <a-radio-group
                    v-decorator="[
                      'isRequired',
                      {
                        rules: [{ required: true, message: '请选择是否必填' }],
                      },
                    ]"
                  >
                    <a-radio :value="0">否</a-radio>
                    <a-radio :value="1">是</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="资料分类" required>
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'materialType',
                      {
                        rules: [{ required: true, message: '请选择资料类型' }],
                      },
                    ]"
                    :options="typesMap.materialType"
                  ></a-select>
                </a-form-item>
                <a-form-item v-if="type" label="是否审核" required v-show="form.getFieldValue('materialType') === 2">
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'isAudit',
                      {
                        rules: [{ required: form.getFieldValue('materialType') === 2, message: '请选择是否审核' }],
                        initialValue: 0,
                      },
                    ]"
                    :options="typesMap.isAudit"
                  ></a-select>
                </a-form-item>
                <a-form-item v-if="type" label="多份资料" required>
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'isMeans',
                      {
                        rules: [{ required: true, message: '请选择' }],
                      },
                    ]"
                    :options="typesMap.isMeans"
                  ></a-select>
                </a-form-item>
                <!-- <a-form-item v-if="type" label="多份资料" required>
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'isMeans',
                      {
                        rules: [{ required: true, message: '请选择' }],
                      },
                    ]"
                    :options="typesMap.isMeans"
                  ></a-select>
                </a-form-item> -->
                <a-form-item v-if="type" label="文件类型" required>
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'fileType',
                      {
                        rules: [{ required: true, message: '请选择' }],
                      },
                    ]"
                    :options="typesMap.fileType"
                  ></a-select>
                </a-form-item>
                <a-form-item label="打印服务" required v-if="productType === 1 && type">
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'isPrint',
                      {
                        rules: [{ required: true, message: '请选择' }],
                      },
                    ]"
                    :options="typesMap.isPrint"
                  ></a-select>
                </a-form-item>
                <a-form-item label="是否寄回" required v-if="form.getFieldValue('materialType') === 2 && type">
                  <a-select
                    class="form-control"
                    v-decorator="[
                      'isSendBack',
                      {
                        rules: [{ required: form.getFieldValue('materialType') === 2, message: '请选择' }],
                      },
                    ]"
                    :options="typesMap.isSendBack"
                  ></a-select>
                </a-form-item>
                <a-form-item v-if="type" label="图片示例">
                  <PictureCardUpload
                    v-decorator="['samplePictureUrl']"
                    preview
                    :itemWidth="150"
                    :itemHeight="187"
                  ></PictureCardUpload>
                </a-form-item>
                <a-form-item v-if="type" label="资料模版">
                  <PictureCardUpload
                    v-decorator="['templateFileUrl']"
                    preview
                    :fileType="''"
                    :tips="'点击上传'"
                    :beforeUpload="beforeUpload"
                    :itemWidth="198"
                    :itemHeight="124"
                  ></PictureCardUpload>
                </a-form-item>
                <a-form-item label="排序" required>
                  <a-input-number class="w-20" v-decorator="['materialSort']" min="0"></a-input-number>
                </a-form-item>
                <a-form-item label="资料描述" :wrapperCol="{ style: 'width: 100%;margin-top:-10px;padding-left:5px' }" required>
                  <RichText
                    v-decorator="['description', { rules: [{ required: true, message: '请输入资料描述' }] }]"
                  ></RichText>
                </a-form-item>
              </a-form>
              <div style="display:flex;justify-content: center;align-items: center;">
                <a-button class="app-btn" type="defult" @click="doSave">保存</a-button>
                <a-button class="app-btn" type="primary" style="margin-left:20px" @click.stop="saveAsModel">另存为模版</a-button>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
      <div style="height:100px;border:1px solid #fff"></div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="goBack">返回</a-button>
      </div>
    </div>
    <MaterialTemplate ref="materialTemplate"></MaterialTemplate>
    <a-modal :title="modal.title" v-model="modal.visible" :width="700">
      <div class="mt-5 mb-10 detailView">
        <a-form class="form" :form="modal.form" :colon="false" layout="inline">
          <a-form-item label="模版名称" required>
            <a-input
              v-decorator="[
                'materialTemplateName',
                {
                  rules: [{ required: true, message: '请输入' }],
                },
              ]"
              placeholder="请输入模版名称"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
      <template slot="footer">
        <a-button @click="handleOk" type="primary">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { toolMixin, queryViewMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import MaterialTemplate from './MaterialTemplate.vue'
import RichText from '@/components/RichText'
import { getCountryList } from '@/service/getData'
export default {
  components: {
    PictureCardUpload,
    MaterialTemplate,
    RichText,
  },
  props: {
    materialTypeId: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    dataType: {
      type: String,
      default: '',
    },
    type: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: Number,
      require: true,
    },
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      modal: {
        visible: false,
        title: '另存为模版',
        form: this.$form.createForm(this),
        data: {},
      },
      form: this.$form.createForm(this),
      materialList: [],
      countryList: [],
      rows: null,
      materialId: '',
      activeKey: [1],
      text: '1dfsdfs',
      selectIndex: null,
    }
  },
  mounted() {
    this.loadList()
    this.init()
  },
  computed: {
    typesMap() {
      return {
        materialType: [
          { value: 1, label: '电子资料' },
          { value: 2, label: '纸质资料' },
        ],
        isAudit: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        isMeans: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        fileType: [
          { value: 1, label: '图片' },
          { value: 2, label: '文件' },
        ],
        isPrint: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        isSendBack: [
          { value: 0, label: '否' },
          { value: 1, label: '是' },
        ],
        differentRegisterList: [
          { value: 0, label: '默认' },
          { value: 1, label: '户籍地与现居地相同时' },
          { value: 2, label: '户籍地与现居地不同时' },
        ],
      }
    },
  },
  methods: {
    addRow() {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = '添加身份类型'
    },
    async init() {
      const list = await getCountryList()
      this.countryList = list.map(v => {
        return {
          ...v,
          value: v.label
        }
      })
    },
    async loadList() {
      // 转单产品
      if (this.productType === 1) {
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
          data: {
            productId: this.productId,
          },
        })
        res.data.forEach(element => {
          element['check'] = false
        })
        this.materialList = res.data
      }
      if (this.productType === 2 || this.productType === 3) {
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
          data: {
            productId: this.productId,
          },
        })
        res.data.forEach(element => {
          element['check'] = false
          element.countryName = element.countryName.split(',')
        })
        this.materialList = res.data
      }
    },
    selectMaterial(row, i) {
      this.form.resetFields()
      this.materialList.forEach((element, index) => {
        if (i === index) {
          row.check = !row.check
        } else {
          element.check = false
        }
      })
      if (row.materialId) {
        this.materialId = row.materialId
        console.log(1)
        this.$nextTick(() => {
          this.safeSetFieldsValue$t(this.form, { ...row })
        })
      } else {
        if (this.rows !== null) {
          console.log(2)
          this.safeSetFieldsValue$t(this.form, { ...this.rows[0], materialName: this.rows[0].materialTemplateName })
        } else {
          console.log(3)
          this.safeSetFieldsValue$t(this.form, { ...row })
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          console.log(params)
          try {
            const data = {
              ...params,
              materialId: this.materialId,
              productId: this.productId,
              materialTypeId: this.materialTypeId,
              countryName: this.productType === 1 ? '' : params.countryName ? params.countryName.join(',') : ''
            }
            // 电子资料，必须审核,不回寄
            if (data.materialType === 1) {
              data.isAudit = 1
              data.isSendBack = 0
            }
            await this.$axios.post('/visa/admin/productMaterial/saveMaterial', {
              data,
            })
            this.$message.success('操作成功!')
            this.loadList()
          } catch (e) {
            console.error(e)
          }
        }
      })
    },

    async add() {
      for (var i = 0; i < this.materialList.length; i++) {
        console.log('?')
        if (this.materialList[i].addType) {
          this.$warning({
            title: '提示',
            content: '有添加中的内容未保存',
          })
          return
        }
      }
      this.materialId = ''
      this.materialList.push({ materialId: '', materialName: '', addType: true, isRequired: false, check: true })
      this.form.resetFields()
    },
    async addFromModal() {
      for (var i = 0; i < this.materialList.length; i++) {
        console.log('?')
        if (this.materialList[i].addType) {
          this.$warning({
            title: '提示',
            content: '有添加中的内容未保存',
          })
          return
        }
      }
      this.materialList.forEach(element => {
        element.check = false
      })
      const rows = await this.$refs.materialTemplate.start({ productType: 1 })
      this.rows = rows
      this.materialId = ''
      this.materialList.push({
        materialId: '',
        materialName: '',
        isRequired: false,
        addType: true,
        check: true
      })
      this.safeSetFieldsValue$t(this.form, { ...rows[0], materialName: rows[0].materialTemplateName })
    },
    remove(row, index) {
      if (row.materialId) {
          this.$confirm({
            title: '提示',
            content: '确定删除?',
            onOk: () => {
              this.$axios.post('/visa/admin/productMaterial/deleteByMaterialId', {
                data: {
                  materialId: row.materialId,
                },
              }).then(res => {
                if (res.success) {
                  this.loadList()
                  this.$message.success('操作成功!')
                } else {
                  // 删除失败提示
                }
              })
            }
          })
      } else {
        this.materialList.splice(index, 1)
      }
      this.loadList(this.materialTypeId)
    },
    saveAsModel() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.resetModal$t()
          this.modal.visible = true
        }
      })
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = this.form.getFieldsValue()
          const { materialTemplateName } = values
          try {
            await this.$axios.post('/visa/admin/productMaterialTemplate/save', {
              data: {
                materialTemplateName,
                productType: 1,
                ...params,
              },
            })
            this.$message.success('操作成功!')
            this.modal.visible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    beforeUpload(file) {
      if (!file.name.toLowerCase().match(/\.(doc|docx|pdf|xls|xlsx|jpg|png|bmp)$/)) {
        this.$message.error('请上传doc、docx、xls、xlsx、pdf文件或jpg、png、bmp图片')
        return false
      }
    },
  },
}
</script>

<style lang="less">
.lyric-enter,
  .lyric-leave-to {
  opacity: 0;
  transform: translateY(10px);
  }
  .lyric-enter-to,
  .lyric-leave {
    opacity: 1;
  }
  .lyric-enter-active,
  .lyric-leave-active {
  transition: all 1.5s;
}
.p-btn {
  border: 1px solid #25cb77;
}
.transition-all {
  border: 1px solid #dfdfdf;
  max-height: 1400px;
  margin-top:10px;
  padding: 30px;
}
.transition-none {
  border: 0px solid #dfdfdf;
  overflow: hidden;
  max-height: 0;
}
.list{
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  background: #d0ecea;
}
.list:hover{
  padding: 15px;
  font-weight: bold;
  // --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  // box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>
